<p class="messageInfo">
  {{parcoursUtilisateur(group)}}
</p>
  <div *ngFor="let field of group.fields; let i = index">
    <app-form-input [prefixId]="prefixId" [parentForm]="formGroup"
                    [field]="field" [subSectionId]="subSectionId"
                    [repeatablePath]="repeatablePath"
                    [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                    [noticeValue]="noticeValue" [index]="index" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
                    (preferenceSelected)="emitDonneePreference($event)"
                    [groupOrSectionId]="group.id" (newField)="newField($event)" (deleteField)="deleteField($event)">
    </app-form-input>
  </div>
  <div *ngFor="let subGroup of group.subGroups; let i = index">
    <app-sub-group
      *ngIf="!subGroup?.hidden" [prefixId]="prefixId" [formGroup]="formGroup"
      [subGroup]="subGroup" [subSectionId]="subSectionId"
      (newSubGroup)="newSubGroup($event)"
      (deleteSubGroup)="deleteSubGroup($event)"
      [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
      [indexGrp]="((indexGrp != ''||isInteger(indexGrp))? indexGrp+'_'+getIncr(subGroup.id): '')"
      [parentsChild]="group.subGroups"
      [getRepeatablePathWithIndexForSubGroup]="getRepeatablePathWithIndexForSubGroup"
      (preferenceSelected)="chargeDonneePreference($event)"
      [noticeValue]="noticeValue"
      [linkForRouter]="linkForRouter" [index]="index">
    </app-sub-group>
  </div>
